var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseTransitionGroup",
    { attrs: { animations: "fade scale" } },
    _vm._l(_vm.$ui.modals, function(modal, index) {
      return _c(
        "aside",
        {
          key: modal.id,
          staticClass:
            "\n            fixed inset-0 p-4 z-50 flex items-center justify-center\n            transition-all transform ease-in duration-300\n        ",
          class: { "opacity-0 scale-90": index < _vm.$ui.modals.length - 1 },
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.$ui.closeModal(modal.id)
            }
          }
        },
        [
          _c(
            modal.component,
            _vm._b({ tag: "component" }, "component", modal.props, false)
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }